export default __webpack_public_path__ + "static/media/college-stamp.51f13b04.png";